export class UserPredictionsListLoad {
  public static readonly type = '[User Predictions List Load] Load';
  constructor(public payload: { filter: string }) {}
}

export class UserPredictionsListInitialState {
  public static readonly type = '[User Predictions List] Set initial state';
}
